// Shared style/format helpers for the SwingGrade terminal.

export const GRADE_CLASS = {
  grade_A: "text-[#00F0FF] bg-[#00F0FF]/10 border-[#00F0FF]/30",
  grade_Strong: "text-[#00FF66] bg-[#00FF66]/10 border-[#00FF66]/30",
  grade_Watch: "text-[#FFD700] bg-[#FFD700]/10 border-[#FFD700]/30",
  grade_Weak: "text-[#FF7F00] bg-[#FF7F00]/10 border-[#FF7F00]/30",
  grade_Avoid: "text-[#FF3B30] bg-[#FF3B30]/10 border-[#FF3B30]/30",
};

export const GRADE_HEX = {
  grade_A: "#00F0FF",
  grade_Strong: "#00FF66",
  grade_Watch: "#FFD700",
  grade_Weak: "#FF7F00",
  grade_Avoid: "#FF3B30",
};

export function actionStyle(action) {
  switch (action) {
    case "CONFIRMED":
      return { cls: "text-[#00FF66] border-[#00FF66]/40 bg-[#00FF66]/10", icon: "flame", label: "CONFIRMED" };
    case "TRIGGER":
      return { cls: "text-[#3B9EFF] border-[#3B9EFF]/40 bg-[#3B9EFF]/10", icon: "zap", label: "TRIGGER" };
    case "SETUP":
      return { cls: "text-[#FFD700] border-[#FFD700]/40 bg-[#FFD700]/10", icon: "target", label: "SETUP" };
    case "CHOP":
      return { cls: "text-gray-400 border-gray-600 bg-white/5", icon: "waves", label: "NO TRADE — CHOP" };
    case "EXPIRED":
      return { cls: "text-gray-500 border-gray-700 bg-white/5", icon: "clock", label: "EXPIRED" };
    case "AVOID":
      return { cls: "text-[#FF3B30] border-[#FF3B30]/40 bg-[#FF3B30]/10", icon: "ban", label: "AVOID" };
    default:
      return { cls: "text-gray-400 border-gray-600 bg-white/5", icon: "minus", label: "NO TRADE" };
  }
}

export const EARN = {
  green: { cls: "text-[#00FF66]", label: ">14d", dot: "#00FF66" },
  yellow: { cls: "text-[#FFD700]", label: "7-14d", dot: "#FFD700" },
  red: { cls: "text-[#FF7F00]", label: "1-6d", dot: "#FF7F00" },
  blocked: { cls: "text-[#FF3B30]", label: "TOMORROW", dot: "#FF3B30" },
  today: { cls: "text-[#FF3B30]", label: "TODAY", dot: "#FF3B30" },
  unknown: { cls: "text-gray-600", label: "—", dot: "#444" },
};

export function num(v, d = 2) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return Number(v).toFixed(d);
}
